import constants from '@/app-configs/constants'
import users from './users'
import Settings from './settings'
import apitokens from './apitokens'
import queuedletters from './queuedletters'
import letters from './letters'
import eventlogs from './eventlogs'
import apisettings from './apisettings'

export default async function mainComponent() {
  const settings = await Settings()

  return [
    {
      title: 'DEBTIA_HOME',
      route: 'home',
      icon: 'HomeIcon',
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
    {
      title: 'DEBTIA_TRANSLATIONS',
      route: 'translations',
      icon: 'GridIcon',
      action: constants.action.permissionTranslationView,
      resource: constants.resource.translation,
      show: true,
    },
    {
      title: 'DEBTIA_ROLE_MANAGEMENT',
      route: 'role-management',
      icon: 'GridIcon',
      action: constants.action.permissionRoleView,
      resource: constants.resource.role,
      show: true,
    },
    ...users,
    ...settings,
    ...apitokens,
    ...queuedletters,
    ...letters,
    ...eventlogs,
    ...apisettings,
  ]
}
